
import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";
import { downloadPDFByPost } from "./utils";

export function getEvolutivo(meses = 12) {
  return API.get(Constants.APIURLS.EVOLUTIVO + meses);
}

export function getResumenCuenta() {
  return API.get(Constants.APIURLS.RESUMENCUENTA);
}

export function getRentabilidadPorMeses(meses) {
  return API.get(Constants.APIURLS.RENTABILIDADPORMESES + meses);
}

export function getBalanceCCI(codCuenta) {
  return API.get(Constants.APIURLS.BALANCECCI + codCuenta);
}

export function getResumenCuentaSMS(guid) {
  return API.get(Constants.APIURLS.ESTADOCUENTASMS + guid);
}

export function getUltimoAporte() {
  return API.get(Constants.APIURLS.ULTIMOAPORTE);
}

export function getEstadosCuenta() {
  return API.get(Constants.APIURLS.ESTADOSCUENTA);
}

export function getReporteEstadoCuenta(fechaCorte: string) {
  downloadPDFByPost(
    API,
    Constants.APIURLS.REPORTEESTADOCUENTA,
    { fechaCorte: fechaCorte, CodUrlFrom: 3 },
    "Estado_Cuenta_" + fechaCorte
  );
}
//Este metodo se ejecuta desde mi cuenta
export function getPublicReporteEstadoCuenta(
  fechaCorte: string,
  cedula: string,
  respuestas: any[], formid: number
) {
  downloadPDFByPost(
    API,
    Constants.APIURLS.PUBLICREPORTEESTADOCUENTA,
    { fechaCorte: fechaCorte, cedula: cedula, respuestas: respuestas, CodUrlFrom: formid },
    "Estado_Cuenta_" + fechaCorte
  );
}

export function getPublicReporteEstadoCuentaPublicSMS(
  fechaCorte: string,
  cedula: string,
  respuestas: any[], formid: number
) {
  downloadPDFByPost(
    API,
    Constants.APIURLS.PUBLICREPORTEESTADOCUENTAPUBLICSMS,
    { fechaCorte: fechaCorte, cedula: cedula, respuestas: respuestas, CodUrlFrom: formid },
    "Estado_Cuenta_" + fechaCorte
  );
}
